export default __webpack_public_path__ + "static/laptop-6c13edda73967eb7c7ed2b2387a941e0.png";